import React from 'react';
import { Tag } from 'antd';
import { MasterConfigs } from '../../../../interfaces/entity';
import MasterComponent from '../../../../components/Forms';

const ExitReasons: React.FC = () => {
    const config: MasterConfigs = {
        api: () => '/exit-reasons',
        modalTitle: (action) => `${action} Exit Reason`,
        isActionTab: true,
        getColumns: () => [
            {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
                width: 150,
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                width: 200,
            }
        ],
        getFormColumns: () => [
            {
                type: 'select',
                name: 'code',
                label: 'Code',
                rules: [{ required: true, message: 'Please select exit reason code' }],
                children: [
                    { name: 'RESIGNATION', value: 'RESIGNATION' },
                    { name: 'TERMINATION', value: 'TERMINATION' },
                    { name: 'RETIREMENT', value: 'RETIREMENT' },
                    { name: 'END_OF_CONTRACT', value: 'END_OF_CONTRACT' },
                    { name: 'ABSENTEEISM', value: 'ABSENTEEISM' },
                    { name: 'MISCONDUCT', value: 'MISCONDUCT' },
                    { name: 'PERFORMANCE_ISSUES', value: 'PERFORMANCE_ISSUES' },
                    { name: 'DEATH', value: 'DEATH' },
                    { name: 'MEDICAL_GROUNDS', value: 'MEDICAL_GROUNDS' },
                    { name: 'OTHER', value: 'OTHER' },
                ],
            },
            {
                type: 'text',
                name: 'name',
                label: 'Name',
                rules: [{ required: true, message: 'Please enter exit reason name' }],
                placeholder: 'Enter exit reason name',
            },
            {
                span: 8,
            },
            {
                type: 'textarea',
                name: 'description',
                label: 'Description',
                placeholder: 'Enter description (optional)',
                span: 16,
                inputTextAreaProps: {
                    rows: 4,
                }
            }
        ],
        actions: [
            {
                name: 'Add Exit Reason',
                actionType: 'Add',
            }
        ],
    };

    return <MasterComponent config={config} />;
};

export default ExitReasons;
